import type { TableUpdateEventDetail } from "@porsche-design-system/components-react"
import { PTableHead, PTableHeadRow } from "@porsche-design-system/components-react"
import { useMemo } from "react"
import type { MessageDescriptor } from "react-intl"
import { FormattedMessage } from "react-intl"
import { TableHeadCellFixed } from "src/components"
import { dealershipListColumns } from "./dealershipListColumns.const"

export interface HeadSortingItem extends TableUpdateEventDetail {
	active: boolean
	hideLabel: boolean
	message: MessageDescriptor
	width: number
}

interface DealershipListTableHeadProps {
	items: HeadSortingItem[]
}

export const DealershipListTableHead = ({ items }: DealershipListTableHeadProps) => {
	return useMemo(
		() => (
			<PTableHead>
				<PTableHeadRow>
					{items.map((item, i) => (
						<TableHeadCellFixed key={i} sort={item} $width={item.width}>
							<FormattedMessage {...item.message} />
						</TableHeadCellFixed>
					))}
					<TableHeadCellFixed $width={dealershipListColumns.chooseLanguage} />
				</PTableHeadRow>
			</PTableHead>
		),
		[items],
	)
}
